module.exports = __webpack_public_path__ + "static/waffles-ee220b0fe01c0d9339341a8fb26c6c2a.jpeg";